import Title from '@/app/components/common/Title'
import { Currency } from '@/app/types'
import classNames from 'classnames'
import { FC } from 'react'
import { CircleFlag } from 'react-circle-flags'

interface CurrencyItemProps {
	currency: Currency
	selected?: boolean
	onSelect: (currency: string) => void
}

const CurrencyItem: FC<CurrencyItemProps> = ({
	currency,
	selected,
	onSelect,
}) => {
	return (
		<div
			onClick={() => onSelect(currency.abbreviation)}
			key={currency.abbreviation}
			data-test-id={`currency-item-${currency.abbreviation}`}
			className={classNames('currency-selector__currency', {
				'currency-selector__currency--selected': selected,
			})}
		>
			<CircleFlag
				countryCode={currency.flag.toLowerCase()}
				className="currency-selector__flag"
			/>

			<div className="flex flex-col">
				<Title level={6} className="uppercase font-semibold">
					{currency.abbreviation}
				</Title>
				<span className="text-xs color-mid-grey">{currency.label}</span>
			</div>
		</div>
	)
}
export default CurrencyItem
